import { IconProps } from "../../utils/global-types/global-types";

const NumberedListIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_9118_138612)">
        <path d="M3.37 7.174h-.913a.457.457 0 0 0 0 .913h.913c.084 0 .152.068.152.152v.152a.15.15 0 0 1-.152.152h-.305C2.478 8.543 2 9.021 2 9.61v.76c0 .253.205.457.457.457h1.521a.457.457 0 0 0 0-.913H2.913V9.61c0-.084.068-.152.152-.152h.305c.587 0 1.065-.478 1.065-1.066V8.24c0-.587-.478-1.065-1.065-1.065M3.37 12.044h-.913a.457.457 0 0 0 0 .913h.913c.084 0 .152.068.152.152v.152a.15.15 0 0 1-.152.152h-.61a.457.457 0 0 0 0 .913h.61c.084 0 .152.068.152.152v.152a.15.15 0 0 1-.152.153h-.913a.457.457 0 0 0 0 .913h.913c.587 0 1.065-.478 1.065-1.066v-.152c0-.226-.073-.435-.194-.608.121-.173.194-.383.194-.61v-.151c0-.588-.478-1.065-1.065-1.065M2.457 3.217h.456V5.5a.457.457 0 0 0 .913 0V2.76a.457.457 0 0 0-.456-.456h-.913a.457.457 0 0 0 0 .913M6.261 4.74h9.13a.608.608 0 1 0 0-1.218h-9.13a.608.608 0 1 0 0 1.217M15.391 8.391h-9.13a.608.608 0 1 0 0 1.218h9.13a.608.608 0 1 0 0-1.218M15.391 13.26h-9.13a.608.608 0 1 0 0 1.218h9.13a.608.608 0 1 0 0-1.217"></path>
      </g>
      <defs>
        <clipPath id="clip0_9118_138612">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default NumberedListIcon;
